const projectConstants = {
    MAX_OPTIONS_PER_PROJECT: 4,
}

export default projectConstants